import type { Locale } from '../locale';
import type { LegalCopy } from './types';

type LegalTexts = Record<Locale, LegalCopy>;

/**
 * The privacy policy and terms in every locale are ~135 kB gzipped, so they stay out of the main bundle:
 * the prerender awaits them up front (entry-server's `ready`), the client loads them only for /privacy and /terms.
 */
let texts: LegalTexts | undefined;

export const legalTexts = (): LegalTexts | undefined => texts;

export const loadLegalTexts = async (): Promise<LegalTexts> => (texts ??= (await import('./texts')).LEGAL_TEXTS);

export type { LegalBlock, LegalCopy, LegalDoc, LegalSection } from './types';
